/**
 * This checking if provided offers Data applicable with provided price
 * @param {Offers} offers
 * @param {FinalPrice} finalPrice Property of price object
 * @returns {boolean}
 */
function isApplicableWithOffer(offers, finalPrice) {
  const finalPriceOfferIds = finalPrice.applicablePromotions;

  if (!Array.isArray(offers) || !Array.isArray(finalPriceOfferIds)) {
    return false;
  }

  const offerIds = offers.map((offer) => offer.promoId);

  return (
    offerIds.length >= finalPriceOfferIds.length
        && offerIds.some((offerId) => finalPriceOfferIds.includes(offerId))
  );
}

export default isApplicableWithOffer;
